/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { createDialogRoute } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { isEmpty } from 'lodash';
import { LetterTemplateValidationResult } from '../../../resources/letter-template.model';

export type LtValidationResultDialogConfig = LetterTemplateValidationResult;

@Component({
  standalone: false,
  selector: 'gh-lt-validation-result-dialog',
  templateUrl: 'lt-validation-result-dialog.component.html',
  styleUrls: ['lt-validation-result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LtValidationResultDialogComponent implements DialogInput<LtValidationResultDialogConfig> {
  input: LtValidationResultDialogConfig;

  get isIncorrectFormat(): boolean {
    return !isEmpty(this.input.incorrectFormat);
  }

  get isMissingInDb(): boolean {
    return !isEmpty(this.input.missingInDb);
  }

  get isParsingFailed(): boolean {
    return !isEmpty(this.input.parsingFailed);
  }

  get isUnavailableForTemplate(): boolean {
    return !isEmpty(this.input.unavailableForTemplate);
  }

  get isValidationPassed(): boolean {
    return !(this.isIncorrectFormat || this.isMissingInDb || this.isParsingFailed || this.isUnavailableForTemplate);
  }
}

export const ltValidationResultDialogRoute = createDialogRoute({
  component: LtValidationResultDialogComponent,
});
